/**
 * WebMCP 旋转工具
 * 控制方块旋转
 */
/* eslint-disable */
var want = require('../../unit/').want;
var t = require('../lang').t;
var actions = require('../../actions').default;
var states = require('../../control/states').default;
var music = require('../../unit/music').music;
var store = require('../../store').default;

/**
 * 执行旋转操作
 */
function rotate() {
  var state = store.getState();

  // 检查锁定状态
  if (state.get('lock')) {
    return { success: false, error: t('游戏处于锁定状态，无法旋转', 'Game is locked, cannot rotate') };
  }

  var cur = state.get('cur');

  // 检查是否有当前方块
  if (cur === null) {
    return { success: false, error: t('没有活动方块', 'No active block') };
  }

  // 如果游戏暂停，先恢复
  if (state.get('pause')) {
    states.pause(false);
  }

  // 执行旋转
  var next = cur.rotate();
  var matrix = state.get('matrix');
  var canRotate = want(next, matrix);

  if (canRotate) {
    // 播放旋转音效
    if (music.rotate) {
      music.rotate();
    }

    store.dispatch(actions.moveBlock(next));

    return {
      success: true,
      message: t('方块已旋转', 'Block rotated'),
      rotation: next.rotateIndex,
    };
  }

  return {
    success: false,
    error: t('无法旋转，空间不足', 'Cannot rotate, not enough space'),
  };
}

/**
 * WebMCP 工具定义
 */
module.exports = {
  name: 'tetris_rotate',
  description: t('旋转当前方块（顺时针）', 'Rotate the current block (clockwise)'),
  inputSchema: {
    type: 'object',
    properties: {},
  },
  execute: function() {
    var result = rotate();
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/rotate.js